// LICENSE : MIT
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _AlminLogger = require("./AlminLogger");

var _AlminLogger2 = _interopRequireDefault(_AlminLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var EventEmitter = require("events");
// FIXME: Almin 0.12 support pull-based Store
// https://github.com/almin/almin/pull/154
// Some Store must to have prevState arguments.
// Call ths Store without argument, throw error
var tryGetState = function tryGetState(store) {
    try {
        return store.getState();
    } catch (error) {
        return null; // not get
    }
};

var SyncLogger = function (_EventEmitter) {
    _inherits(SyncLogger, _EventEmitter);

    function SyncLogger(_ref) {
        var console = _ref.console;

        _classCallCheck(this, SyncLogger);

        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        _this._logMap = {};
        _this._releaseHandlers = [];
        _this.logger = console;
        return _this;
    }

    /**
     * flush current log buffer
     */


    SyncLogger.prototype.flushBuffer = function flushBuffer() {
        this._logMap.clear();
    };

    /**
     * start logging for {@link context}
     * @param {Context} context
     */


    SyncLogger.prototype.startLogging = function startLogging(context) {
        var _this2 = this;

        var onWillExecuteEachUseCase = function onWillExecuteEachUseCase(payload, meta) {
            _this2.logger.groupCollapsed("\uD83D\uDD16 " + meta.name, meta.timeStamp);
            _this2._logMap[meta.useCase.name] = meta.timeStamp;
            _this2.logger.log(meta.useCase.name + " will execute");
        };
        var onDispatch = function onDispatch(payload) {
            _this2.logger.info("\uD83D\uDD25 Dispatch:" + String(payload.type), payload);
        };
        var onChange = function onChange(stores) {
            stores.forEach(function (store) {
                var state = tryGetState(store);
                _this2.logger.groupCollapsed("\uD83D\uDCBE Store:" + state.name + " is Changed");
                _this2.logger.info(state !== null ? state : store);
                _this2.logger.groupEnd();
            });
        };
        var onDidExecuteEachUseCase = function onDidExecuteEachUseCase(payload, meta) {
            _this2.logger.log(meta.useCase.name + " did executed");
        };
        var onErrorHandler = function onErrorHandler(payload, meta) {
            _this2._logError(payload, meta);
        };

        var onCompleteUseCase = function onCompleteUseCase(payload, meta) {
            var useCase = meta.useCase;
            var startTimeStamp = _this2._logMap[useCase.name];
            var takenTime = meta.timeStamp - startTimeStamp;
            _this2.logger.log(useCase.name + " is completed");
            _this2.logger.info("Take time(ms): " + takenTime);
            _this2.logger.groupEnd(useCase.name);
            _this2.emit(_AlminLogger2.default.Events.output);
        };
        // release handler
        this._releaseHandlers = [context.onChange(onChange), context.onDispatch(onDispatch), context.onWillExecuteEachUseCase(onWillExecuteEachUseCase), context.onDidExecuteEachUseCase(onDidExecuteEachUseCase), context.onCompleteEachUseCase(onCompleteUseCase), context.onErrorDispatch(onErrorHandler)];
    };

    /**
     * add log to logger
     * @param {*} chunk
     */


    SyncLogger.prototype.addLog = function addLog(chunk) {
        this.logger.log(chunk);
    };

    SyncLogger.prototype._logError = function _logError(payload, meta) {
        // if has useCase and group by useCase
        var error = payload.error || "something wrong";
        if (meta.useCase) {
            this.logger.error(meta.useCase.name, error);
        } else {
            this.logger.error(error);
        }
    };

    /**
     * release event handlers
     */


    SyncLogger.prototype.release = function release() {
        this._releaseHandlers.forEach(function (releaseHandler) {
            return releaseHandler();
        });
        this._releaseHandlers.length = 0;
    };

    return SyncLogger;
}(EventEmitter);

exports.default = SyncLogger;
module.exports = exports["default"];
//# sourceMappingURL=SyncLogger.js.map


//////////////////
// WEBPACK FOOTER
// ./~/almin-logger/lib/SyncLogger.js
// module id = 230
// module chunks = 0